import { characterActions, serviceDataActions } from '../actions';
import { CreatureAccessors, CreatureGroupFlagEnum, DB_STRING_GROUP_SIDEKICK, DB_STRING_TAG_SIDEKICK, } from '../engine/Creature';
import { ExtraAccessors, ExtraGenerators, ExtraUtils, HACK_VEHICLE_GROUP_ID, } from '../engine/Extra';
import { RuleDataGenerators, RuleDataUtils } from '../engine/RuleData';
import { rulesEngineSelectors } from '../selectors';
import { TypeScriptUtils } from '../utils';
import { MessageManager } from './MessageManager';
export class ExtrasManager extends MessageManager {
    constructor(params) {
        super(params);
        this.handleAcceptOnSuccess = (onSuccess) => {
            return () => {
                typeof onSuccess === 'function' && onSuccess();
            };
        };
        this.handleRejectOnError = (onError) => {
            return () => {
                typeof onError === 'function' && onError();
            };
        };
        this.handleAdd = ({ extra, quantity, selectedGroup }, onSuccess, onError) => {
            var _a;
            const extraId = ExtraAccessors.getId(extra);
            if (this.isCreature(extra)) {
                if (selectedGroup && typeof extraId === 'number') {
                    let names = [];
                    if (quantity > 1) {
                        for (let i = 1; i <= quantity; i++) {
                            names.push(`${ExtraAccessors.getName(extra)} ${i}`);
                        }
                    }
                    else {
                        names.push(null);
                    }
                    this.dispatch(characterActions.creatureCreate(selectedGroup, extraId, names, this.handleAcceptOnSuccess(onSuccess)));
                }
            }
            else if (this.isVehicle(extra)) {
                if (typeof extraId === 'string') {
                    this.dispatch(serviceDataActions.vehicleMappingCreate(extraId, (_a = ExtraAccessors.getName(extra)) !== null && _a !== void 0 ? _a : 'Vehicle', this.handleAcceptOnSuccess(onSuccess)));
                }
            }
        };
        this.handleRemove = ({ extra }, onSuccess, onError) => {
            const mappingId = ExtraAccessors.getMappingId(extra);
            if (this.isCreature(extra)) {
                this.dispatch(characterActions.creatureRemove(mappingId));
            }
            else if (this.isVehicle(extra)) {
                this.dispatch(serviceDataActions.vehicleMappingRemove(mappingId));
            }
        };
        this.handleSetActive = ({ extra, isActive }, onSuccess, onError) => {
            this.dispatch(characterActions.creatureActiveSet(ExtraAccessors.getMappingId(extra), isActive));
        };
        //UTILS
        this.getExtraData = (extra) => {
            if (this.isCreature(extra)) {
                const creatureLookup = rulesEngineSelectors.getCreatureLookup(this.state);
                return ExtraUtils.getTypedExtra(extra, creatureLookup);
            }
            else if (this.isVehicle(extra)) {
                const vehicleLookup = rulesEngineSelectors.getVehicleLookup(this.state);
                return ExtraUtils.getTypedExtra(extra, vehicleLookup);
            }
            else {
                return null;
            }
        };
        this.getGroupOptions = () => {
            const ruleData = rulesEngineSelectors.getRuleData(this.state);
            let creatureGroupOptions = RuleDataGenerators.getCreatureGroupGroupedOptions(ruleData, false);
            return [
                {
                    optGroupLabel: 'Creature',
                    options: creatureGroupOptions,
                },
                {
                    optGroupLabel: 'Object',
                    options: [
                        {
                            label: 'Vehicle',
                            value: HACK_VEHICLE_GROUP_ID,
                        },
                    ],
                },
            ];
        };
        this.getCreatureGroupInfo = (groupId) => {
            if (groupId === null) {
                return null;
            }
            const ruleData = rulesEngineSelectors.getRuleData(this.state);
            return RuleDataUtils.getCreatureGroupInfo(groupId, ruleData);
        };
        this.getCurrentGroupInfos = (extras) => {
            const ruleData = rulesEngineSelectors.getRuleData(this.state);
            return ExtraGenerators.generateCurrentExtraGroupInfos(extras, ruleData);
        };
        this.isCreatureGroup = (groupId) => {
            return groupId === HACK_VEHICLE_GROUP_ID;
        };
        this.isVehicleGroup = (groupId) => {
            return groupId === HACK_VEHICLE_GROUP_ID;
        };
        this.hack__isSidekickGroup = (groupId) => {
            const creatureGroupInfo = this.getCreatureGroupInfo(groupId);
            return !!creatureGroupInfo && creatureGroupInfo.name === DB_STRING_GROUP_SIDEKICK;
        };
        this.isCreature = (extra) => {
            return ExtraUtils.isCreature(extra);
        };
        this.isVehicle = (extra) => {
            return ExtraUtils.isVehicle(extra);
        };
        this.isHomebrew = (extra) => {
            return ExtraAccessors.isHomebrew(extra);
        };
        this.getChallengeOptions = () => {
            const ruleData = rulesEngineSelectors.getRuleData(this.state);
            return RuleDataGenerators.getChallengeOptions(ruleData);
        };
        this.getCreaturesFilteredByGroupFlags = (creatures, groupId) => {
            if (groupId === null) {
                return creatures;
            }
            let groupInfo = this.getCreatureGroupInfo(groupId);
            if (groupInfo && groupInfo.flagInfoLookup[CreatureGroupFlagEnum.CANNOT_BE_SWARM]) {
                creatures = creatures.filter((creature) => !CreatureAccessors.isSwarm(creature));
            }
            if (this.hack__isSidekickGroup(groupId)) {
                creatures = creatures.filter((creature) => CreatureAccessors.getTags(creature).includes(DB_STRING_TAG_SIDEKICK));
            }
            return creatures;
        };
        this.getSourceNames = (extra) => {
            const ruleData = rulesEngineSelectors.getRuleData(this.state);
            const sources = ExtraAccessors.getSources(extra);
            return sources
                .map((sourceMapping) => RuleDataUtils.getSourceDataInfo(sourceMapping.sourceId, ruleData))
                .filter(TypeScriptUtils.isNotNullOrUndefined)
                .map((sourceDataInfo) => sourceDataInfo.description)
                .filter(TypeScriptUtils.isNotNullOrUndefined);
        };
    }
}
